import { render, staticRenderFns } from "./CaData.vue?vue&type=template&id=79727b92&"
import script from "./CaData.vue?vue&type=script&lang=ts&"
export * from "./CaData.vue?vue&type=script&lang=ts&"
import style0 from "./CaData.vue?vue&type=style&index=0&id=79727b92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports